import { render, staticRenderFns } from "./SecondaryContracts.vue?vue&type=template&id=50e03dbb&scoped=true&"
import script from "./SecondaryContracts.vue?vue&type=script&lang=js&"
export * from "./SecondaryContracts.vue?vue&type=script&lang=js&"
import style0 from "./SecondaryContracts.vue?vue&type=style&index=0&id=50e03dbb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50e03dbb",
  null
  
)

export default component.exports